<template>
  <div class="d-flex align-center mr-4">
    <v-switch
      :input-value="isOn"
      :loading="saving"
      :disabled="saving"
      label="Agrupación de contactos"
      hide-details
      dense
      class="mt-0 pt-0"
      @change="askConfirm"
    />
    <v-dialog v-model="confirm" max-width="460" persistent>
      <v-card>
        <v-card-title class="text-h6">
          {{ target ? "Activar" : "Desactivar" }} agrupación de contactos
        </v-card-title>
        <v-card-text>
          Esto afecta la asignación de leads nuevos de esta inmobiliaria desde
          el siguiente lead.
          <span v-if="target">
            Los leads repetidos se agruparán en un contacto y heredarán el
            asesor.
          </span>
          <span v-else>
            Los leads nuevos volverán al flujo anterior (sin vinculación). Los
            datos ya vinculados se conservan.
          </span>
          <v-alert v-if="error" type="error" text dense class="mt-3 mb-0">{{
            error
          }}</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="saving" @click="cancel">Cancelar</v-btn>
          <v-btn color="primary" :loading="saving" @click="save"
            >Confirmar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { SetContactGrouping } from "@/api/real-estate-group-api.js";

export default {
  name: "ContactGroupingToggle",
  props: {
    groupId: { type: String, required: true },
    // valor actual del modelo: 'on' | 'off' | ''
    value: { type: String, default: "" }
  },
  data() {
    return {
      current: this.value,
      confirm: false,
      target: false,
      saving: false,
      error: ""
    };
  },
  computed: {
    isOn() {
      return this.current === "on";
    }
  },
  watch: {
    value(val) {
      this.current = val;
    }
  },
  methods: {
    askConfirm(val) {
      this.target = !!val;
      this.error = "";
      this.confirm = true;
    },
    cancel() {
      this.confirm = false;
      // fuerza al switch a reflejar el valor real
      const prev = this.current;
      this.current = "";
      this.$nextTick(() => (this.current = prev));
    },
    async save() {
      this.saving = true;
      this.error = "";
      try {
        const res = await SetContactGrouping({
          accessGroup: this.groupId,
          enabled: this.target
        });
        this.current = res.contact_grouping;
        this.$emit("input", this.current);
        this.confirm = false;
        this.$snotify.success(
          `Agrupación de contactos ${this.isOn ? "activada" : "desactivada"}`
        );
      } catch (e) {
        this.error = e.message;
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>
